module.exports = __webpack_public_path__ + "static/media/gallery1.a5c0b5f8.png";